@if (!profileUrl) {
  <div
    [matTooltip]="fullName"
    class="mr-2 user-image d-flex justify-content-center align-items-center"
    [ngStyle]="{ width: computedWidth, height: computedHeight }"
    >
    <h6
      class="user-text font-weight-bold m-0"
      [ngStyle]="{ 'font-size': dynamicFontSize }"
      >
      {{ initials }}
    </h6>
    <div class="online_circle">
      <!-- {{ statusTitle }} -->
      <span [innerHTML]="statusSvg"></span>
    </div>
  </div>
}

@if (profileUrl) {
  <div class="position-relative">
    <img
      [matTooltip]="fullName"
      [src]="profileUrl"
      alt=""
      class="avatar_img mr-2 rounded-circle"
      [ngStyle]="{ width: computedWidth, height: computedHeight }"
      />
    <div class="svg_circle">
      <!-- {{ statusTitle }} -->
      <span [innerHTML]="statusSvg"></span>
    </div>
  </div>
}
